import { create } from 'zustand';

/**
 * The reviewer's in-progress choices (wireframe §10): which candidate — or
 * "Neither" — is selected per review item, and which items were skipped for
 * now. Kept out of component state so a reviewer can move between items
 * (and screens) without losing a choice; the decision itself is a mutation
 * against `POST /app/api/review/:id` and the queue is server data.
 */
export type ReviewChoice = string | null; // source_record_id, or null = neither

export interface ReviewState {
  /** Keyed by `${entityId}:${source}`; absent = nothing chosen yet. */
  choices: Record<string, ReviewChoice>;
  skipped: Record<string, true>;
  choose: (key: string, choice: ReviewChoice) => void;
  clear: (key: string) => void;
  skip: (key: string) => void;
  reset: () => void;
}

export const reviewKey = (entityId: string, source: string): string =>
  `${entityId}:${source}`;

export const useReviewStore = create<ReviewState>()((set) => ({
  choices: {},
  skipped: {},
  choose: (key, choice) => set((s) => ({ choices: { ...s.choices, [key]: choice } })),
  clear: (key) =>
    set((s) => {
      const { [key]: _gone, ...choices } = s.choices;
      return { choices };
    }),
  skip: (key) => set((s) => ({ skipped: { ...s.skipped, [key]: true } })),
  reset: () => set({ choices: {}, skipped: {} }),
}));
